import React, { useContext, type ReactElement } from "react";

import { appContext } from "../shared/AppContextProvider.js";
import Category from "./Category.js";

/**
 * The what size do I need page content.
 *
 * @returns The component.
 */
export function WhatSizeDoINeed(): ReactElement {
	const { pouches } = useContext(appContext);
	return (
		<div>
			{pouches.map((pouch) => (
				<Category key={pouch._id} pouch={pouch} />
			))}
		</div>
	);
}
